import React from "react";
import { PageHeader } from "../components/PageHeader";
import CurrencyConverter from "../components/CurrencyConverter";
import RatesBoard from "../components/RatesBoard";

export default function Cevirici() {
  return (
    <>
      <PageHeader
        eyebrow="Araçlar"
        title="Döviz Çevirici"
        description="Anlık piyasa satış kurları üzerinden para birimleri arası dönüşüm yapın."
      />
      <section className="py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-5 lg:px-8">
          <CurrencyConverter />
          <p className="text-center text-sm text-slate-500 mt-6">
            Sonuçlar anlık piyasa satış kurları temel alınarak hesaplanır. Bilgilendirme amaçlıdır.
          </p>
        </div>
      </section>
      <div className="pb-10">
        <RatesBoard />
      </div>
      <div className="pb-20" />
    </>
  );
}
